//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import { mapGetters, mapActions, mapMutations } from 'vuex';
import KModal from 'kolibri.coreVue.components.KModal';
import KRadioButton from 'kolibri.coreVue.components.KRadioButton';

export default {
  name: 'FacilityModal',
  components: {
    KModal,
    KRadioButton,
  },
  data() {
    const facilityId = this.$store.state.facilityId || this.$store.getters.facilities[0].id;
    return {
      // currentFacilityId uses session, with is anonymous in sign-in-page
      selectedFacility: facilityId,
    };
  },
  computed: {
    ...mapGetters(['facilities']),
  },
  methods: {
    ...mapActions(['getFacilityConfig']),
    ...mapMutations({
      setFacilityId: 'SET_FACILITY_ID',
      setLoginError: 'CORE_SET_LOGIN_ERROR',
    }),
    submitAndClose() {
      this.setFacilityId(this.selectedFacility);
      this.setLoginError('');
      this.getFacilityConfig(this.selectedFacility).then(() => this.$emit('submit'));
    },
  },
  $trs: {
    facilitySelectionPrompt: 'Which facility do you want to sign in to?',
    submitFacilitySelectionButtonPrompt: 'Select',
    facilitySelectionModalHeader: 'Select a facility',
    close: 'Close',
  },
};

